import { Link } from "react-router-dom";
import React, { Component } from "react";
import "../../styles/css/DashboardComponents/DashboardHeader.css";

const userRoleId = localStorage.getItem("userRoleId");

class DashboardHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="headerCardRoot">
        <div className="adminHeaderCardMain">
          <div className="headerCardTitle">
            <span>Dashboard</span>
          </div>
          <div className="adminHeaderCardBody">
            <div className="adminCardHeaderButtons">
              {userRoleId === "1" ||
              userRoleId === "2" ||
              userRoleId === "4" ? (
                <div className="cardButtonLinks">
                  {/* <Link
                    to="/survey-request"
                    className="currLink manageUsersLink"
                  >
                    <button className="bidBtn createJobBtn">
                      Survey requests
                    </button>
                  </Link> */}

                  <Link to="/all-jobs" className="currLink manageUsersLink">
                    <button className="bidBtn createJobBtn">View jobs</button>
                  </Link>

                  <Link
                    to="/companyUserMgt"
                    className="currLink manageUsersLink"
                  >
                    <button className="greyColorBtn">Manage users</button>
                  </Link>
                  <Link
                    to="/JobCreation/0"
                    className="currLink manageUsersLink"
                  >
                    <button className="bidBtn createJobBtn">
                      Create a job
                    </button>
                  </Link>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DashboardHeader;



// WEBPACK FOOTER //
// ./src/components/DashboardComponents/DashboardHeader.js